import { useEffect, useState } from 'react';

/**
 * Trailing-edge debounce of a changing value. Used by the list pages'
 * search boxes: the input stays instantly responsive (controlled by the
 * raw value) while the SERVER query key only updates after the user
 * pauses typing — one request per pause instead of one per keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
